import { loginGuard, reloadMessages } from '@/galaxy-cruise/utils';
import { Component, Vue, Watch } from "vue-property-decorator";
import { Route } from 'vue-router';
import { stopDemoPlay } from '../demo_play';
import ConfigPanel from './ConfigPanel/index.vue';
import HeaderMenu from './HeaderMenu/index.vue';
import MainButtons from "./MainButtons/index.vue";
import MyPage from './MyPage/index.vue';
import Passport from './Passport/index.vue';
import QuestionPanel from './QuestionPanel/index.vue';
import SpecialityItems from "./SpecialityItems/index.vue";
import { store } from '@/store';
import { asyncAlert } from '@/galaxy-cruise/components/AsyncAlert';
import WelcomeWindow from "./WelcomeWindow/index.vue";
import MessagesWindow from "./MessagesWindow/index.vue";
import moment from 'moment'

@Component({
  components: {
    MainButtons,
    QuestionPanel,
    HeaderMenu,
    MyPage,
    Passport,
    SpecialityItems,
    ConfigPanel,
  },
})
export default class extends Vue {
  static async beforeEnter(to: Route, from: Route, next: (path: string | void) => void) {
    stopDemoPlay()
    await loginGuard(to, from, next)
  }

  async mounted() {
    // @ts-ignore
    this.$refs.questionPanel.refreshPanelShow()

    this.$watch(() => store.galaxyCruise.session && store.galaxyCruise.session.quest, (quest) => {
      store.currentFrame.modules.sspData.activeReruns = quest!.level.layer === 'dud' ? ['pdr2_wide', 'pdr2_dud'] : ['pdr2_wide']
    }, { immediate: true })

    if (store.galaxyCruise.session!.user.personal_setting!.show_startup_hint) {
      await asyncAlert({ component: WelcomeWindow, closable: false })
    }

    await this.checkNewMessages()
  }

  private async checkNewMessages() {
    const { last } = await reloadMessages()
    const messages = store.galaxyCruise.messages
    if (messages.length > 0 && messages[0].published_at > last) {
      await asyncAlert({
        component: MessagesWindow, props: {
          initialLastMessageCheck: moment(last).toISOString(),
        },
      })
    }
  }
}
